import { getCampaignGroups } from '@percent/workplace-giving/api/campaigns/getCampaignGroups/getCampaignGroups'
import { useLogger, useQuery } from '@percent/workplace-giving/common/hooks'
import { GivingCampaignGroupRow } from './Row/GivingCampaignGroupRow'

export function GivingCampaignGroups(): JSX.Element | null {
  const { logError } = useLogger()
  const { data, isLoading, error } = useQuery(['givingCampaignGroups'], getCampaignGroups)

  if (error) {
    logError(error)

    return null
  }

  if (isLoading || !data) {
    return null
  }

  return (
    <>
      {data.map(g => (
        <GivingCampaignGroupRow key={g.id} group={g} />
      ))}
    </>
  )
}
